// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__g6-QO","slogan":"style_slogan__Cr31w","actions":"style_actions__ADJSE"};